import React, { AnchorHTMLAttributes } from 'react';
import Link from 'next/link';

import useI18n from '@i18n';
import sendGoal from '@utils/metrics/ymSendGoal';

export interface IBaseSemanticLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    to: string;
    goalName?: string;
}

const BaseSemanticLink: React.FC<IBaseSemanticLinkProps> = props => {
    const { locale } = useI18n();

    const { to, goalName, ...baseLinkProps } = props;

    const isFile = /\.pdf/.test(to);

    const isReactLink = to.startsWith('/') && !isFile;

    const linkProp = to.includes('app-auth') ? { href: `${to}` } : { href: `/${locale}${to}` };

    const newProps = {
        ...baseLinkProps,
        ...linkProp,
    };

    if (goalName) {
        newProps.onClick = () => sendGoal(goalName);
    }

    const { href, ...otherProps } = newProps;

    if (isReactLink) {
        return (
            <Link href={href} prefetch={false} {...otherProps}>
                {props.children}
            </Link>
        );
    }

    return <a {...newProps}>{props.children}</a>;
};

export default BaseSemanticLink;
